const wolfvapes = {
    id: 'wolfvapes',
    publicSiteName: 'Wolf Vapes',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#d96107',
            secondary: '#120e0c',
            color1: '#f46d07',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/wolfvapes/favicon.ico',
        logo: '/wolfvapes/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default wolfvapes